import {
  TipTapChipEditor,
  type TipTapChipEditorProps,
  type TipTapChipEditorRef,
} from "components/editor/email-editor";
import { forwardRef } from "react";
import { WithDictation } from "../components/WithDictation";
import { toolbarMicSx } from "../components/DictationMicButton";
import { tiptapTarget } from "../utils/dictationTargets";

/**
 * The chip editor with voice dictation: the mic at the right end of its
 * toolbar (needs `showToolbar`), the dictation box over the editor. Render
 * `TipTapChipEditor` instead to leave dictation off on a screen.
 */
export const TipTapChipEditorWithDictation = forwardRef<
  TipTapChipEditorRef,
  TipTapChipEditorProps
>((props, ref) => (
  <WithDictation<TipTapChipEditorRef>
    toTarget={(handle) => tiptapTarget(handle?.getEditor())}
    disabled={props.readOnly}
    editorRef={ref}
    // EmailEditorToolbar's side padding.
    micSx={toolbarMicSx("16px")}
    render={(slots) => <TipTapChipEditor {...props} {...slots} />}
  />
));

TipTapChipEditorWithDictation.displayName = "TipTapChipEditorWithDictation";
